import { Subscription } from '../../../data/dietitian/domain/subscription/subscription';

export interface SideBarItem {
  icon: string;
  iconType?: 'iconly' | 'bs';
  label: string;
  selected: boolean;
  navigateTo?: string;
  url?: string;
  tabValue: SideBarNavigationTabs | MySideBarNavigationTabs;
  condition: (sub: Subscription | undefined) => boolean;
  onlyDesktop: boolean;
  warningMessage?: string;
}

export enum SideBarNavigationTabs {
  QUESTIONS = 'DASHBOARD',
  TEMPLATES = 'TEMPLATES',
  QUIZ_TEMPLATES = 'QUIZ_TEMPLATES',
  DOCUMENTS = 'DOCUMENTS',
  TRACKERS = 'TRACKERS',
  GROUPS = 'GROUPS',
  MON_SUIVI_DIET_PLUS = 'MON_SUIVI_DIET_PLUS',
  ACCOUNT = 'ACCOUNT',
  USER_GUIDE = 'USER_GUIDE',
  NUTRITIONS = 'NUTRITIONS',
  BILLING = 'BILLING',
  BACK_OFFICE = 'BACK_OFFICE',
  MSD_AI = 'MSD_AI',
  AUDIO_AI = 'AUDIO_AI',
}

export enum MySideBarNavigationTabs {
  HOME = 'HOME',
  MESSAGE = 'MESSAGE',
  ACCOUNT = 'ACCOUNT',
  DOCUMENT = 'DOCUMENT',
  LOGOUT = 'LOGOUT',
}
